import styles from './index.module.scss';
import { Icons } from '..';
// import { useJumpPage } from '@/pages/user/index_dev/hooks/init';
import { useRouter } from '@/hooks/useRouter';
import cls from 'classnames';
import close from '../../assets/svg/close_20x20.svg';

export type DrawerHeaderProps = {
  title?: string;
  onClose?: () => void;
  needPadding?: boolean;
  showClose?: boolean;
  titleStyle?: any;
  onCloseAll?: () => void;
  showLeftIcon?: boolean;
};
export const DrawerHeader = (props: DrawerHeaderProps) => {
  const {
    needPadding,
    showClose = true,
    showLeftIcon = true,
    titleStyle = { titleAlign: 'left', fontWeight: '500' },
    onCloseAll,
  } = props;
  const { jump } = useRouter();
  return (
    <div
      className={cls(styles.header, {
        [styles.padding]: needPadding,
      })}
    >
      <div className={styles.title} style={titleStyle}>
        {showLeftIcon && (
          <Icons.IconArrowLeft
            style={{ marginRight: 8 }}
            onClick={() => {
              props?.onClose ? props?.onClose() : jump(-1);
            }}
          />
        )}
        <span
          className={cls(styles.left, styles.title, {
            'title-left': titleStyle.titleAlign === 'left',
          })}
          style={{
            fontWeight: titleStyle?.fontWeight,
          }}
        >
          {props.title}
        </span>
      </div>
      {/* {showClose && <Icons.IconClose className={styles.close} onClick={onCloseAll} size={28} />} */}
      {showClose && <img src={close} className={styles.close} onClick={onCloseAll} />}
    </div>
  );
};
